import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import ScreenLockRotationIcon from '@mui/icons-material/ScreenLockRotation';
const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

interface ownProps {
    open: boolean;
}

const OrientationModal : React.FC<ownProps> = ({ open }: ownProps) => {{

  return (
    <div>
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
           <ScreenLockRotationIcon sx={{ marginLeft: 20, fontSize: 50}} /> 
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            Please rotate your device into portrait orientation.
          </Typography>
        </Box>
      </Modal>
    </div>
  );
}
}
export default OrientationModal